import { FlaskConical } from 'lucide-react';

import { useI18n } from '../../i18n/useI18n';

export function LocalDemoBanner() {
  const { t } = useI18n();
  if (import.meta.env.VITE_FINANCEGO_DEMO !== 'true') return null;

  return (
    <aside aria-label={t('common.demoMode')} className="local-demo-banner">
      <FlaskConical aria-hidden="true" />
      <strong>{t('common.demoMode')}</strong>
      <span>{t('common.demoDescription')}</span>
    </aside>
  );
}
